module.exports = __webpack_public_path__ + "src/img/warnRed.83a5e260.svg";